import React, { Component } from 'react';
import { StyleSheet, css } from 'aphrodite';
import moment from 'moment';
import async from 'async';
import Grid from '@material-ui/core/Grid';
import Icon from '@material-ui/core/Icon';
import { UiHelper } from '../common/helpers/UiHelper';
import { ApiHelper } from '../common/helpers/ApiHelper';
import { Helper } from '../common/helpers/Helper';
import { Controller } from '../common/Controller';
import { CustomFormFieldsDialogV2 } from '../components/CustomFormFieldsDialogV2';
import { ActionHeaderbar } from '../components/ActionHeaderbar';
import { PopOverV2 } from '../components/PopOverV2';
import { AppConfig } from '../AppConfig';
import { AppHelper } from '../helpers/AppHelper';
import { appData } from '../data/AppData'
import { AppTheme } from '../styles/AppTheme';
import { ColourPalette } from '../styles/AppColourPalette';
import { CommonStyles } from '../styles/Styles';

export class ClientPlaceCamsDetails extends Component {
  constructor(props) {
    super(props);
    this.updateImageIntervalFnId = null;
    this.currentOrg = Controller.get().userMgr().getCurrentOrg()
    this.placeId = this.props.match.params.id ? this.props.match.params.id : null;
    this.responseByKey = {}
    this.state = {
      updateMemberDialog: false,
      confirmDeleteView: false,
      inProcess: false,
      dialogAction: '',
      dialogTitle: '',
      selectedItem: {},
      anchorEl: null,
      fullScreenMode: Controller.get().userMgr().getFullScreenMode() ? 'EXIT FULLSCREEN' : 'FULLSCREEN',
      isHoveredID: null,
      colNumber: 4,
      fetchState: ApiHelper.State.LOADING,
    }
  }

  componentDidMount() {
    this.fetchItems();
    this.updateImageIntervalFnId = setInterval(() => {
      this.updateImageFeedUrl();
      this.fetchItems();
    }, AppConfig.imageFeedRefreshInterval);
  }

  componentWillUnmount() {
    if (this.updateImageIntervalFnId) {
      clearInterval(this.updateImageIntervalFnId);
    }
  }

  fetchItems = () => {
    const placeId = this.placeId
    async.parallel(
      [
        function (callback) {
          ApiHelper.call(
            { method: 'GET', endPoint: ApiHelper.makeUrlPath(['places', placeId]) }, callback)
        }
      ],
      function (err, results) {
        if (err) {
          this.setState({
            fetchState: ApiHelper.State.ERROR,
            errMsg: Helper.getErrorMsg(err)
          })
          return
        }

        for (const c of results[0].cams) {
          if (!c.flags) continue
          c.flags = AppHelper.arrayToCsv(c.flags)
        }

        this.setBreadcrumbs(results[0])

        this.setState({
          item: AppHelper.attachTsToURL(results[0]),
          fetchState: ApiHelper.State.READY,
        })
      }.bind(this))
  }

  setBreadcrumbs = (item) => {
    this.breadcrumbs = [
      {
        title: 'Places',
        to: '/orgs/' + item.orgId + '/places'
      },
      {
        title: item.name,
        to: ''
      },
    ]
  }

  updateImageFeedUrl() {
    const item = this.state.item
    if (item && item.cams) {
      this.setState({
        item: AppHelper.attachTsToURL(item)
      })
    }
  }

  handleHover = (e, index) => {
    this.setState({
      isHoveredID: index
    });
  }

  setColNumber = (value) => {
    this.setState({
      colNumber: value
    })
  }

  getInfoString = (item) => {
    if (!item.latestEventTs) {
      return 'No events yet'
    }
    const minutes = moment().diff(moment(item.latestEventTs), 'minutes')
    const seconds = moment().diff(moment(item.latestEventTs), 'seconds')
    if(seconds < 60) {
      return 'Last Event ' + seconds + ' seconds ago'
    } else if (minutes < 60) {
      return 'Last Event ' + minutes + ' minutes ago'
    } else {
      const hours = moment().diff(moment(item.latestEventTs), 'hours')
      if (hours > 24) {
        const days = moment().diff(moment(item.latestEventTs), 'days')
        return 'Last Event ' + days + ' days ago'
      } else {
        return 'Last Event ' + hours + ' hrs ago'
      }
    }
  }

  getLatestEvent = (item) => {
    return (
      <div className={css(Styles.latestEventContainer)}>
        <p className={css(Styles.latestEventContent)}>
          {this.getInfoString(item)}
        </p>
        {(Controller.get().userMgr().isProductUser() || Controller.get().userMgr().isAdminUser()) &&
          <p className={css(Styles.camIdText)}>Cam ID #{item._id}</p>
        }
      </div>
    )
  }

  tileClick = (e, item) => {
    Controller.get().pushRoute({ pathname: '/places/' + item.placeId, search: '?camId=' + item._id })
  }

  liveClick = (e, item) => {
    if (!e) {
      const e = window.event;
      e.cancelBubble = true;
    }
    if (e.stopPropagation) {
      e.stopPropagation();
    }
    Controller.get().pushRoute('/places/' + item.placeId + '/cams/' + item._id)
  }

  renderDefautIcon = () => {
    return (
      <div className={css(Styles.iconContainer)}>
        <Icon className={css(Styles.icons)} color='primary'>videocam</Icon>
      </div>
    )
  }

  renderLiveImg = (item) => {
    return (
      <img
        style={{ width: '100%' }}
        src={item.urlJpeg}
        alt='Live Image Stream'
        className={css(Styles.imgContent)}
        /*onError={(e) => {
          e.target.src = require('../assets/images/error.svg')
        }}*/
      />
    )
  }

  renderLatestEventImg = (item) => {
    return (
      <img
        style={{ width: '100%' }}
        src={item.latestEventImageUrl}
        alt='Latest Event'
        className={css(Styles.imgContent)}
        /*onError={(e) => {
          e.target.src = require('../assets/images/error.svg')
        }}*/
      />
    )
  }

  getImageView = (item, index) => {
    let highlight = false
    if (moment(item.lastSeenTs).valueOf() < moment(item.latestEventTs).valueOf()) {
      highlight = true
    }
    if(!item.latestEventTs) {
      highlight = false
    }

    return (
      <Grid
        item xs={12}
        xs={12}
        sm={this.state.colNumber}
        className={css(Styles.tileContainer)}
        onClick={(e) => this.tileClick(e, item)}>
        <div
          className={highlight ? css(Styles.tileContent, Styles.tileContentHighlight) : css(Styles.tileContent)}
          onMouseEnter={e => this.handleHover(e, index)}
          onMouseLeave={e => this.handleHover(e, null)}>
          {this.state.isHoveredID === index &&
            <div
              className={css(Styles.imgOuterContainer, Styles.imgOuterContainerHover)}>
              {item.urlJpeg &&
                this.renderLiveImg(item)
              }

              {!item.urlJpeg && item.latestEventImageUrl &&
                this.renderLatestEventImg(item)
              }

              {!item.urlJpeg && !item.latestEventImageUrl &&
                this.renderDefautIcon()
              }

              <div className={css(Styles.imgOuterHover)}>
                <div className={css(Styles.hoverButtonOuterContainer)}>
                  <div
                    className={this.state.colNumber < 3 ?
                      css(Styles.hoverButtonContainer, Styles.hoverButtonStyle) : css(Styles.hoverButtonContainer)}
                    onClick={(e) => this.tileClick(e, item)}>
                    <p className={css(CommonStyles.margin)}>Events</p>
                  </div>
                  {item.urlJpeg &&
                    <div
                      className={this.state.colNumber < 3 ?
                        css(Styles.hoverButtonContainer, Styles.hoverButtonStyle) : css(Styles.hoverButtonContainer)}
                      onClick={(e) => this.liveClick(e, item)}>
                      <p className={css(CommonStyles.margin)}>Live</p>
                    </div>
                  }
                </div>
              </div>
            </div>
          }

          {this.state.isHoveredID !== index &&
            <div
              className={css(Styles.imgOuterContainer)}>
              {item.urlJpeg &&
                this.renderLiveImg(item)
              }

              {!item.urlJpeg && item.latestEventImageUrl &&
                this.renderLatestEventImg(item)
              }

              {!item.urlJpeg && !item.latestEventImageUrl &&
                this.renderDefautIcon()
              }
            </div>
          }

          <div className={css(Styles.tileDetailOuterContainer)}>
            <div className={css(Styles.tileDetailNameContainer)}>
              <div className={css(Styles.tileDetailContainerDot)}></div>
              <p className={css(Styles.tileDetailContainerName)}>{item.name}</p>
            </div>

            <div className={css(Styles.tileDetailContainer)}>
              {this.getLatestEvent(item)}
              <div className={css(Styles.editContainer)}>
                <div onClick={(e) => this.editClick(e, item)} className={css(Styles.editContent)} >
                  <img src={require('../assets/images/more-rounded.svg')} />
                </div>
              </div>
            </div>
          </div>
        </div>
      </Grid>
    )
  }

  setFullscreen = () => {
    if (this.state.fullScreenMode === 'FULLSCREEN') {
      this.setState({ fullScreenMode: 'EXIT FULLSCREEN' })
      Controller.get().userMgr().setFullScreenMode(true)
    } else {
      this.setState({ fullScreenMode: 'FULLSCREEN' })
      Controller.get().userMgr().setFullScreenMode(false)
    }
    window.location.reload();
  };

  resetToDefaultValues = () => {
    this.responseByKey = {}
    this.setState({
      updateMemberDialog: false,
      inProcess: false,
      dialogAction: '',
      dialogTitle: '',
      selectedItem: {},
      anchorEl: null,
      confirmDeleteView: false,
    })
  }

  showAddMemberDialog = () => {
    this.setState({
      updateMemberDialog: true,
      dialogTitle: 'Add a Cam',
      dialogAction: 'add'
    })
  }

  showConfirmDeleteView = () => {
    this.setState({
      confirmDeleteView: true,
      inProcess: false,
      dialogAction: '',
    })
  }

  showDeleteMemberDialog = () => {
    this.responseByKey = this.state.selectedItem
    this.setState({
      anchorEl: null,
      updateMemberDialog: true,
      dialogTitle: 'Delete a Cam',
      dialogAction: 'delete',
    })
  }

  showUpdateMemberDialog = () => {
    this.responseByKey = this.state.selectedItem
    this.setState({
      anchorEl: null,
      updateMemberDialog: true,
      dialogTitle: 'Edit a Cam',
      dialogAction: 'edit',
    })

  }

  onPopOverClick = (key) => {
    if (key === 'edit') {
      this.showUpdateMemberDialog()
    } else if (key === 'delete') {
      this.showDeleteMemberDialog()
    } else if (key === 'downloadReport') {
      Controller.get().pushRoute('/reports/' + this.placeId)
    } else if (key === 'viewInfo') {
      this.showViewMemberDialog()
    }
  }

  showViewMemberDialog = () => {
    this.responseByKey = this.state.selectedItem
    this.setState({
      anchorEl: null,
      updateMemberDialog: true,
      dialogTitle: 'Camera',
      dialogAction: 'viewInfo',
    })
  }

  editClick = (e, item) => {
    if (!e) {
      const e = window.event;
      e.cancelBubble = true;
    }
    if (e.stopPropagation) {
      e.stopPropagation();
    }
    this.setState({
      anchorEl: e.currentTarget,
      selectedItem: item
    })
  }

  editClickClose = () => {
    this.setState({ anchorEl: null })
  }

  renderUpdateMemberDialog = () => {
    const formFields = []
    for (const key in appData.camFields) {
      formFields.push(appData.camFields[key])
    }
    return (
      <CustomFormFieldsDialogV2
        onClose={this.resetToDefaultValues}
        dialogOpen={this.state.updateMemberDialog}
        dialogTitle={this.state.dialogTitle}
        confirmDeleteView={this.state.confirmDeleteView}
        inProcess={this.state.inProcess}
        selectedItem={this.state.selectedItem}
        deleteItem={() => this.deleteMember()}
        action={this.state.dialogAction}
        showConfirmDeleteView={this.showConfirmDeleteView}
        responseByKey={this.responseByKey}
        onSuccess={this.addMember}
        formFields={formFields}
        enableValidation={this.state.dialogAction === 'delete' ? false : true}
        formDisabled={this.state.dialogAction === 'delete' ? true : false}>
      </CustomFormFieldsDialogV2>
    )
  }

  addMember = () => {
    this.setState({
      inProcess: true
    })
    let options = {}
    const id = this.state.selectedItem ? this.state.selectedItem._id : null
    if (!id) {
      options = {
        method: 'POST',
        endPoint: ApiHelper.makeUrlPath(['cams']),
        jsonBody: {
          camData: {
            name: this.responseByKey.name,
            urlJpeg: this.responseByKey.urlJpeg,
            urlVideo: this.responseByKey.urlVideo,
            flags: this.responseByKey.flags,
            streamContentHeight: this.responseByKey.streamContentHeight,
            streamContentWidth: this.responseByKey.streamContentWidth,
            placeId: this.placeId,
          }
        }
      }
    } else {
      const body = {
        camData: {
          name: this.responseByKey.name,
          urlJpeg: this.responseByKey.urlJpeg,
          urlVideo: this.responseByKey.urlVideo,
          flags: this.responseByKey.flags,
          streamContentHeight: this.responseByKey.streamContentHeight,
          streamContentWidth: this.responseByKey.streamContentWidth,
          placeId: this.placeId,
        }
      }
      options = {
        method: 'PUT',
        endPoint: ApiHelper.makeUrlPath(['cams', id]),
        jsonBody: body
      }
    }
    Helper.removeNullValues(options.jsonBody.userData)
    console.log('options', options)
    ApiHelper.call(options, function (err, data) {
      if (err) {
        const msg = err.message ? err.message : 'An error occurred, please try again. Contact customer care if problem persists.';
        this.setState({
          errMsg: msg,
          errCode: err.respCode,
          inProcess: false,
        })
        return
      } else {
        this.resetToDefaultValues()
        this.fetchItems();
      }
    }.bind(this))
  }

  deleteMember = () => {
    const id = this.state.selectedItem ? this.state.selectedItem._id : null
    if (!id) {
      return
    }
    this.setState({
      inProcess: true
    })
    const options = {
      method: 'DELETE',
      endPoint: ApiHelper.makeUrlPath(['cams', id]),
    }
    ApiHelper.call(options, function (err, data) {
      if (err) {
        const msg = err.message ? err.message : 'An error occurred, please try again. Contact customer care if problem persists.';
        this.setState({
          errMsg: msg,
          errCode: err.respCode,
          inProcess: false,
        })
        return
      } else {
        this.resetToDefaultValues()
        this.fetchItems();
      }
    }.bind(this))
  }

  onRowItemClick = (item) => {
    Controller.get().pushRouteWithParams(
      '/places/' + item._id + '/cams',
      {
        item: item
      }
    )
  }

  renderCams = () => {
    return (
      <div className={css(CommonStyles.innerMainContainer)}>
        <div className={css(Styles.innerContainer)}>
          <Grid
            container
            spacing={4}>
            {this.state.item &&
              this.state.item.cams.length > 0 ?
              this.state.item.cams.map((item, index) => {
                return (
                  this.getImageView(item, index)
                )
              })
              :
              <p className={css(CommonStyles.emptyView)}>No Cams added yet</p>
            }
          </Grid>
        </div>
      </div>
    )
  }

  getActionHeaderbarTitle = () => {
    if (this.state.item && this.state.item.cams && this.state.item.cams.length === 1) {
      return 'Live Grid | ' + this.state.item.cams.length + ' Cam'
    } else if (this.state.item && this.state.item.cams && this.state.item.cams.length > 1) {
      return 'Live Grid | ' + this.state.item.cams.length + ' Cams'
    } else {
      return 'Live Grid | 0 Cam'
    }
  }

  render() {
    if (this.state.fetchState === ApiHelper.State.LOADING) {
      return UiHelper.componentLoadingView();
    } else if (this.state.fetchState === ApiHelper.State.ERROR) {
      return UiHelper.errorView(this);
    } else {
      return this.readyView();
    }
  }

  readyView = () => {
    const open = Boolean(this.state.anchorEl);
    const id = open ? 'simple-popover' : undefined;
    return (
      <div className={css(CommonStyles.outerMainContainer)}>
        <ActionHeaderbar
          breadcrumbs={this.breadcrumbs}
          title={this.getActionHeaderbarTitle()}
          items={this.state.item.cams}
          buttonOneAction={this.showAddMemberDialog}
          buttonOneTitle={'ADD NEW CAM'}
          inProcess={this.state.inProcess}
          fullScreen={true}
          fullScreenMode={this.state.fullScreenMode}
          setFullscreen={this.setFullscreen}
          slider={true}
          sliderFunction={this.sliderFunction}
          setColNumber={this.setColNumber}
        />

        {this.renderCams()}

        {this.renderUpdateMemberDialog()}

        <PopOverV2
          id={id}
          open={open}
          items={(Controller.get().userMgr().isProductUser() || Controller.get().userMgr().isAdminUser()) ? appData.popOverFields : appData.regularPopOverFields}
          anchorEl={this.state.anchorEl}
          onPopOverClick={this.onPopOverClick}
          editClickClose={this.editClickClose}
        />
      </div>
    )
  }
}


const Styles = StyleSheet.create({
  innerContainer: {
    width: '90%',
    display: 'flex',
    flexDirection: 'column',
    marginTop: 65,
    marginBottom: 50
  },
  tileContainer: {
    display: 'flex',
    flexDirection: 'column',
  },
  tileContent: {
    display: 'flex',
    flex: 1,
    flexDirection: 'column',
    borderRadius: '0 10px 10px 10px',
    backgroundColor: AppTheme.secondaryColor,
    position: 'relative',
    border: '2px solid' + AppTheme.secondaryColor,
    cursor: 'pointer',
    /*':hover': {
      border: '2px solid #FF682A'
    }*/
  },
  tileContentHighlight: {
    border: '2px solid #FF682A'
  },
  tileDetailOuterContainer: {
    display: 'flex',
    '@media(max-width: 767px)': {
      flexDirection: 'column'
    }
  },
  tileDetailNameContainer: {
    backgroundColor: AppTheme.primaryBackground,
    padding: 8,
    display: 'flex',
    alignItems: 'center',
    borderRadius: '0px 0px 0px 10px',
    '@media(max-width: 767px)': {
      borderRadius: 0
    }
  },
  tileDetailContainer: {
    display: 'flex',
    flex: 1,
    padding: 10,
    alignItems: 'center',
    backgroundColor: '#1E2530',
    borderRadius: '0px 0px 10px 0px',
    '@media(max-width: 767px)': {
      borderRadius: '0px 0px 10px 10px',
    }
  },
  latestEventContent: {
    margin: 0,
    color: AppTheme.white,
    opacity: 0.5,
    fontSize: 12
  },
  camIdText: {
    margin: 0,
    marginTop: 5,
    color: AppTheme.white,
    opacity: 0.5,
    fontSize: 10
  },
  tileDetailContainerName: {
    color: AppTheme.white,
    fontSize: AppTheme.fontSizeTitle,
    margin: 0,
    fontWeight: 'bold',
    textTransform: 'uppercase',
    whiteSpace: 'nowrap',
    overflow: 'hidden',
    textOverflow: 'ellipsis'
  },
  editContainer: {
    flex: 1,
    display: 'flex',
    justifyContent: 'flex-end'
  },
  editContent: {
    cursor: 'pointer',
    width: 30,
    height: 30,
    borderRadius: '50%',
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    ':hover': {
      backgroundColor: AppTheme.secondaryColor
    }
  },
  imgOuterContainer: {
    flex: 1,
    //width: '100%',
    // minHeight: 200,
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    backgroundColor: AppTheme.primaryBackground,
    borderRadius: '0px 10px 0px 0px'
  },
  imgContent: {
    maxWidth: '100%',
    maxHeight: '100%',
    borderRadius: '0px 10px 0px 0px'
  },
  imgOuterContainerHover: {
    position: 'relative'
  },
  imgOuterHover: {
    display: 'flex',
    width: '100%',
    height: '100%',
    position: 'absolute',
    backgroundColor: 'rgba(107,95,253,0.8)',
    borderRadius: '0px 10px 0px 0px',
    justifyContent: 'center',
    alignItems: 'center'
  },
  hoverButtonOuterContainer: {
    display: 'flex',
  },
  hoverButtonContainer: {
    padding: '7px 15px',
    border: '1px solid ' + AppTheme.white,
    borderRadius: 4,
    fontSize: '12',
    color: AppTheme.white,
    minWidth: 60,
    margin: 8,
    textAlign: 'center',
    cursor: 'pointer',
    ':hover': {
      backgroundColor: 'rgba(255,255,255,0.5)',
      color: '#323B4D'
    }
  },
  hoverButtonStyle: {
    minWidth: 'unset',
    padding: 10
  },
  iconContainer: {
    flex: 1,
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    minHeight: 200,
  },
  icons: {
    color: ColourPalette.color1,
    fontSize: 70
  }
})


// WEBPACK FOOTER //
// ./src/screens/ClientPlaceCamsDetails.js